module.exports = __webpack_public_path__ + "static/media/close~hKFpNpUn.f2ec1f7d.svg";